import React from 'react';
import './email-form.css';

export default function EmailForm() {
    return (
        <div className="email-form">
            <iframe title="Embedded Wufoo Form" scrolling="no" src="https://joshalmostt.wufoo.com/embed/z16cks70glal29/"> <a href="https://joshalmostt.wufoo.com/forms/z16cks70glal29/">Fill out my Wufoo form!</a> </iframe>
        </div>
    )
}